module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Vj2d"))).then(() => parcelRequire('1iHdE'));